<template>
  <div class="card is-min-width-500">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t('ajoutDevis.popUpDuplicationLigne.title') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="card-content">
      <div class="columns is-multiline is-justify-content-center">
        <b-field
          :label="$t('ajoutDevis.popUpDuplicationLigne.qteACreer')"
          class="column mgb-0 obligatoire">
          <b-input
            v-model.number="qteACreer"
            :use-html5-validation="false"
            type="number"
            min="1"
            ref="qteInput"/>
        </b-field>
      </div>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <button class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </button>
          </div>
          <div class="is-pulled-left boutonAction">
            <button class="button is-addOrEdit" @click="dupliquer()">
              {{ $t('general.button.sauvegarder') }}
            </button>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      qteACreer: 1,
    };
  },
  methods: {
    dupliquer() {
      this.$emit('makeDuplication', this.qteACreer);
      this.$parent.close();
    },
  },
  mounted() {
    this.$refs.qteInput.focus();
  },
};
</script>
